export default __webpack_public_path__ + "files/1_3_5_Draft_Bioeconomy_Strategy_Southern_Great_Plain_Hungary.docx";